export default {
  state: {
    token: null,
    user: null
  }
};
